import AuthService from '../../shared/services/AuthService';
import { AxiosError } from 'axios';
import { CollectionVm } from '../../content/models/ResourceModel/Collection';
import Config from '../../shared/config';
import CourseVm from '../../content/models/CourseVm';
import Lesson from '../../content/models/Lesson';
import { ResourceLinkModel } from '../../content/models/ResourceModel/ResourceLink';
import { SearchBy } from '../../shared/components/keyword/KeywordLocate';
import useSWRMutation from 'swr/mutation';

interface SearchArgType {
  searchBy: SearchBy;
  searchText: string;
  isAuthorSearch: boolean;
}

export function useSearchContent() {
  const userkey = AuthService.Userkey;
  const listCourseSearchUrl = `${Config.API}/api/search`;

  const headers = {
    Authorization: `Bearer ${AuthService.getAccessToken()}`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  const fetchSearchResults = async (
    url: string,
    { arg }: { arg: SearchArgType }
  ) => {
    return fetch(
      `${url}/${arg.searchBy}${arg.isAuthorSearch ? '/author' : ''}`,
      {
        headers,
        method: 'POST',
        body: JSON.stringify({ userkey, search: arg.searchText, limit: 30 })
      }
    ).then(async (res) => res.json());
  };

  // Get search results.
  const {
    trigger: getSearch,
    isMutating: searching,
    data: searhResults,
    error: searchError
  } = useSWRMutation<
    (CourseVm | Lesson | CollectionVm | ResourceLinkModel)[],
    AxiosError<Error>,
    any,
    SearchArgType
  >(listCourseSearchUrl, fetchSearchResults);

  return {
    searching,
    getSearch,
    searhResults
  };
}
